import { Fragment } from 'react';
import { Box, Typography } from '@mui/material';
import styled from '@mui/material/styles/styled';
import { Tooltip } from 'app/shared-components';
import { formatComparisonValue } from '../utils';

const TableRow = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'columnCount',
})(({ theme, columnCount }) => ({
  display: 'grid',
  gridTemplateColumns: `minmax(220px, 1.5fr) repeat(${columnCount}, minmax(0, 1fr))`,
  alignItems: 'center',
  padding: '12px 0',
  borderBottom: `1px solid ${theme.palette.grey[100]}`,
  '&:last-child': {
    borderBottom: 'none',
  },
}));

const PricingTable = ({ rows, plans, currency, description }) => (
  <Box mt="32px">
    <Typography variant="body2" color="accent.500" mb="12px">
      {description}
    </Typography>
    <Box>
      {rows.map((row, rowIndex) => (
        <Fragment key={row.key}>
          {row.section && row.section !== rows[rowIndex - 1]?.section && (
            <Typography variant="body2" fontWeight={600} color="accent.900" mt="20px" mb="4px">
              {row.section}
            </Typography>
          )}
          <TableRow columnCount={plans.length}>
            <Box display="flex" alignItems="center" gap="6px">
              <Typography variant="body2" color="accent.700">
                {row.name}
                {row.hint && (
                  <Tooltip
                    text={row.hint}
                    icon="heroicons-outline:information-circle"
                    iconColor="accent.400"
                    iconSize={16}
                    display="inline-block"
                    ml="6px"
                  />
                )}
              </Typography>
            </Box>
            {plans.map((plan) => (
              <Typography
                key={`${row.key}-${plan.id}`}
                variant="body2"
                fontWeight={400}
                color="accent.700"
                display="flex"
                justifyContent="center"
                textAlign="center"
              >
                {formatComparisonValue(plan.comparisonValues[row.key], row, currency)}
              </Typography>
            ))}
          </TableRow>
        </Fragment>
      ))}
    </Box>
  </Box>
);

export default PricingTable;
